import api from '../api/apiClient'
import type { SystemDefault } from '../models/system-default'

export const systemRepository = {
  getDefaults: async (): Promise<SystemDefault[]> => {
    const response = await api.get('/system-defaults/all')
    return response.data.data
  }
}